import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./QuillEditor.module.scss";

const defaultToolbar = [
  [
    { header: [1, 2, 3, false] },
    "bold",
    "italic",
    { color: ["", "black", "grey", "red", "orange", "green", "blue", "violet"] },
    { list: "ordered" },
    { list: "bullet" },
    { indent: "-1" },
    { indent: "+1" },
    { align: [] },
    "code-block",
    "clean",
  ],
];

interface QuillEditorProps {
  value: string;
  onChange: (content: string) => void;
  placeholder?: string;
  toolbarOptions?: any;
}

export function QuillEditor({
  value = "",
  onChange,
  placeholder = "Write your note here...",
  toolbarOptions = defaultToolbar,
}: QuillEditorProps) {
  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={{ toolbar: toolbarOptions }}
    />
  );
}
